// extracted by mini-css-extract-plugin
module.exports =  {"root":"a6vUahrL2lOnAEY4r7to"};